import dayjs from "dayjs";
import forge from "node-forge";
import CryptoJS from "crypto-js";
import {
  refreshToken,
  clearUserSession,
  scheduleTokenRefresh,
} from "./services/auth";

export default {
  data: function () {
    return {
      GROUPS: [
        { animal: "ປານ້ອຍ", numbers: ["01", "41", "81"] },
        { animal: "ຫອຍ", numbers: ["02", "42", "82"] },
        { animal: "ຫ່ານ", numbers: ["03", "43", "83"] },
        { animal: "ນົກຍຸງ", numbers: ["04", "44", "84"] },
        { animal: "ສິງ", numbers: ["05", "45", "85"] },
        { animal: "ເສືອ", numbers: ["06", "46", "86"] },
        { animal: "ໝູ", numbers: ["07", "47", "87"] },
        { animal: "ກະຕ່າຍ", numbers: ["08", "48", "88"] },
        { animal: "ຄວາຍ", numbers: ["09", "49", "89"] },
        { animal: "ນາກນໍ້າ", numbers: ["10", "50", "90"] },
        { animal: "ໝາ", numbers: ["11", "51", "91"] },
        { animal: "ມ້າ", numbers: ["12", "52", "92"] },
        { animal: "ຊ້າງ", numbers: ["13", "53", "93"] },
        { animal: "ແມວບ້ານ", numbers: ["14", "54", "94"] },
        { animal: "ໜູ", numbers: ["15", "55", "95"] },
        { animal: "ເຜິ້ງ", numbers: ["16", "56", "96"] },
        { animal: "ນົກຍາງ", numbers: ["17", "57", "97"] },
        { animal: "ແມວປ່າ", numbers: ["18", "58", "98"] },
        { animal: "ແມງກະເບື້ອ", numbers: ["19", "59", "99"] },
        { animal: "ຂີ້ເຂັບ", numbers: ["00", "20", "60"] },
        { animal: "ນົກແອ່ນ", numbers: ["21", "61"] },
        { animal: "ນົກກາງແກ", numbers: ["22", "62"] },
        { animal: "ລີງ", numbers: ["23", "63"] },
        { animal: "ກົບ", numbers: ["24", "64"] },
        { animal: "ແຫຼວ", numbers: ["25", "65"] },
        { animal: "ນາກບິນ", numbers: ["26", "66"] },
        { animal: "ເຕົ່າ", numbers: ["27", "67"] },
        { animal: "ໄກ່", numbers: ["28", "68"] },
        { animal: "ອ່ຽນ", numbers: ["29", "69"] },
        { animal: "ປາໃຫຍ່", numbers: ["30", "70"] },
        { animal: "ກຸ້ງ", numbers: ["31", "71"] },
        { animal: "ງູ", numbers: ["32", "72"] },
        { animal: "ແມງມຸມ", numbers: ["33", "73"] },
        { animal: "ກວາງ", numbers: ["34", "74"] },
        { animal: "ແບ້", numbers: ["35", "75"] },
        { animal: "ເຫງັນ", numbers: ["36", "76"] },
        { animal: "ຫຼິ່ນ", numbers: ["37", "77"] },
        { animal: "ເໝັ້ນ", numbers: ["38", "78"] },
        { animal: "ກະປູ", numbers: ["39", "79"] },
        { animal: "ນົກອິນຊີ", numbers: ["40", "80"] },
      ],
      GATEWAYS: [
        {
          code: "BCEL",
          name: "BCEL One",
          namelao: "ທະນາຄານການຄ້າຕ່າງປະເທດລາວ BCELOne",
          logo: "Buy/Icon/BCEL.png",
          marketid: 8,
        },
        {
          code: "LDB",
          name: "LDB Trust",
          namelao: "ທະນາຄານພັດທະນາລາວ LDB",
          logo: "Buy/Icon/LDB.png",
          marketid: 10,
        },
        {
          code: "JDB",
          name: "JDB Yes",
          namelao: "ທະນາຄານຮ່ວມພັດທະນາ JDB",
          logo: "Buy/Icon/JDB.png",
          marketid: 11,
        },
        {
          code: "APB",
          name: "APB Mepom",
          namelao: "ທະນາຄານສົ່ງເສີມກະສິກຳ",
          logo: "Buy/Icon/APB.png",
          marketid: 22,
        },
        {
          code: "STB",
          name: "ST Hub",
          namelao: "ທະນາຄານ ST",
          logo: "Buy/Icon/STB.png",
          marketid: 12,
        },
        {
          code: "LVB",
          name: "Lao Viet Bank",
          namelao: "ທະນາຄານ ລາວ-ຫວຽດ",
          logo: "Buy/Icon/LVB.png",
          marketid: 19,
        },
        // {
        //   code: "IB",
        //   name: "IB Cool",
        //   namelao: "ທ/ຄ ອິນໂດຈີນ (ໄວໆນີ້)",
        //   logo: "Buy/Icon/IB.png",
        //   marketid: 21,
        // },
        {
          code: "POINT",
          name: "ຊໍາລະດ້ວຍຄະແນນ",
          namelao: "ຄະແນນຂອງທ່ານ",
          logo: "point.png",
          marketid: 1,
        },
      ],
      PRODUCTS: [
        {
          name: "ໝາກອາງຸ່ນຂຽວ",
          price: 150000,
          photo:
            "https://img.freepik.com/free-photo/green-grape_1203-6914.jpg?t=st=1736578772~exp=1736582372~hmac=8f49dbf48a1aa1c212d79123de6da1ab77b5b92f71c92d040add6e536da904e6&w=1800",
        },
        {
          name: "ໝາກສີດາ",
          price: 60000,
          photo:
            "https://img.freepik.com/free-photo/guava-fruit_74190-2534.jpg?t=st=1736577458~exp=1736581058~hmac=78b1302aa4131b981cbdc506b59956e4900144d1abe02dc84dd860bf86e75e71&w=1480",
        },
        {
          name: "ໝາກອາໂວກາໂດ",
          price: 100000,
          photo:
            "https://img.freepik.com/free-photo/mix-ripped-green-avocados-white-wooden-board_482257-22893.jpg?t=st=1736578677~exp=1736582277~hmac=8f6093f8f2e592a18027cf16498ec7686fa807701a3ccdf85e6e9f4aa999ca20&w=1800",
        },
        {
          name: "ໝາກລິນຈີ່",
          price: 100000,
          photo:
            "https://img.freepik.com/free-photo/lychee-fruit-photography_1150-13684.jpg?t=st=1736577572~exp=1736581172~hmac=8fd6eb3514f27af15b158e1bfc5ec41b0e4bc19f9320fc2eec9a3e89c81d311e&w=1800",
        },
        {
          name: "ໝາກເງາະ",
          price: 80000,
          photo:
            "https://img.freepik.com/free-photo/pink-fruits-with-green-hairs_1122-1219.jpg?t=st=1736577640~exp=1736581240~hmac=05b06697a04742e2af45d07c4ec7fdaa4a82b81ad948d08286716de83aeb8f5f&w=1800",
        },
        {
          name: "ໝາກເດື່ອ",
          price: 150000,
          photo:
            "https://img.freepik.com/free-photo/green-fig-white_144627-24562.jpg?t=st=1736577675~exp=1736581275~hmac=5a8cb8e2c778b77097c03aed9c22f1f75a213e7bdc8cd549325ed74d41c1ef84&w=1380",
        },
        {
          name: "ໝາກຮຸ່ງ",
          price: 60000,
          photo:
            "https://img.freepik.com/free-photo/fresh-papaya-fruit_144627-34217.jpg?t=st=1736577730~exp=1736581330~hmac=edfc62c0a79671b2aa7ff22482656af6661bb2e6671989d38e023223e62c743a&w=1480",
        },
        {
          name: "ໝາກອາງຸ່ນດຳ",
          price: 150000,
          photo:
            "https://img.freepik.com/free-photo/grape-white-background_1323-248.jpg?t=st=1736579006~exp=1736582606~hmac=d4e3c1040864484282332f479f7956265d836bfca632acc97f68a486a13f60ea&w=1800",
        },
        {
          name: "ໝາກໂມ",
          price: 100000,
          photo:
            "https://img.freepik.com/free-photo/fresh-watermelon_1339-290.jpg?t=st=1736577903~exp=1736581503~hmac=2bedd901e3f3714ef7edaec8a1afdc65d6dc00197d9e2a718583f8c09013a51b&w=1800",
        },
        {
          name: "ໝາກມັງກອນ",
          price: 80000,
          photo:
            "https://img.freepik.com/free-photo/dragon-fruit_1203-8053.jpg?t=st=1736577974~exp=1736581574~hmac=a66df16bf973295c9bdc2476d059ad1146f9cf9f5c44f9ea5f66e2aed21239cf&w=1800",
        },
        {
          name: "ໝາກພ້າວ",
          price: 40000,
          photo:
            "https://img.freepik.com/free-photo/coconut-fruit_74190-2755.jpg?t=st=1736578129~exp=1736581729~hmac=315adaaf67275ef28fc59968ae2618c82a7c0c7c6cca2d1715dd3574d1a3e37a&w=1800",
        },
        {
          name: "ໝາກກ້ຽງ",
          price: 120000,
          photo:
            "https://img.freepik.com/free-photo/front-close-view-fresh-whole-oranges-juicy-sour-white-surface_140725-19918.jpg?t=st=1736578194~exp=1736581794~hmac=8e319ba3f282c455dee6ac511fe3c7b4285a195bc00ceac39224292262db79d6&w=1800",
        },
      ],
    };
  },
  filters: {
    formatnumber(x) {
      if (!x) return 0;
      if (x) {
        if (typeof x === "string") {
          x = parseFloat(x);
        }
        return (x % 1 != 0 ? x.toFixed(2) : x)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      return x;
    },
    displaydigit(x, ishide) {
      if (!x) return "";
      if (x.length === 1) x = `0${x}`;
      return (ishide ? "******" : x).substring(0, x.length);
    },
    datetime(x) {
      if (x) {
        return dayjs(x).format("DD/MM/YYYY HH:mm:ss");
      }
      return x;
    },
    date(x) {
      if (x) {
        return dayjs(x).format("DD/MM/YYYY");
      }
      return x;
    },
    time(x) {
      if (x) {
        return dayjs(x).format("HH:mm:ss");
      }
      return x;
    },
  },
  methods: {
    generateCodeVerifier(length) {
      const possible =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";
      let verifier = "";
      for (let i = 0; i < length; i++) {
        verifier += possible.charAt(
          Math.floor(Math.random() * possible.length),
        );
      }
      return verifier;
    },
    generateCodeChallenge(codeVerifier) {
      const hash = CryptoJS.SHA256(codeVerifier);
      const base64 = CryptoJS.enc.Base64.stringify(hash);
      return base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
    },

    /**
     * ສ້າງ PKCE pair (code_verifier + code_challenge)
     */
    generatePKCE() {
      const codeVerifier = this.generateCodeVerifier(128);
      const codeChallenge = this.generateCodeChallenge(codeVerifier);
      return {
        codeVerifier,
        codeChallenge,
        codeChallengeMethod: "S256",
      };
    },
    jsonParse(s) {
      if (typeof s === "string") {
        try {
          return JSON.parse(s);
        } catch (error) {
          console.error("ErrorparsingJSON", JSON.stringifyerror);
        }
      }
      return s;
    },
    t(words) {
      const lang = this.$store.get("lang");
      if (lang === "en" || lang == 0) {
        return words[0] ?? words[1];
      }
      return words[1] ?? words[0];
    },
    displaydigit(x, ishide) {
      if (!x) return "";
      return (ishide ? "******" : x).substring(0, x.length);
    },
    getAnimalImage(num) {
      if (!num) return "";
      let num2 = num;
      if (num2.length >= 2) {
        num2 = num2.slice(-2);
      } else {
        num2 = "0" + num2;
      }
      const animal = this.GROUPS.find((g) => g.numbers.includes(num2));
      if (!animal) return "";
      return `Animals/${animal.numbers[0]}.png`;
    },
    getAnimalName(num) {
      if (!num) return "";
      let num2 = num;
      if (num2.length >= 2) {
        num2 = num2.slice(-2);
      } else {
        num2 = "0" + num2;
      }

      const match = this.GROUPS.find((g) => {
        return g.numbers.includes(num2);
      });
      return match ? match.animal : "";
    },
    formatnumber(x) {
      if (x) {
        if (typeof x === "string") {
          x = parseFloat(x);
        }
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      return "";
    },
    datetime(x) {
      if (x) {
        return dayjs(x).format("DD/MM/YYYY HH:mm:ss");
      }
      return x;
    },
    date(x) {
      if (x) {
        return dayjs(x).format("DD/MM/YYYY");
      }
      return x;
    },
    async sign(data, privateKeyPem, flutter) {
      if (!privateKeyPem) {
        try {
          privateKeyPem = await flutter.callHandler("readsecure", "privateKey");
        } catch (error) {
          console.error("ERRORsign", JSON.stringify(error));
          privateKeyPem = await flutter.callHandler("getdata", "privateKey");
        }
      }

      let publicKeyPem = null;
      try {
        publicKeyPem = await flutter.callHandler("readsecure", "publicKey");
      } catch (error) {
        publicKeyPem = await flutter.callHandler("getdata", "publicKey");
      }

      try {
        const privateKey = forge.pki.privateKeyFromPem(privateKeyPem);
        const md = forge.md.sha512.create();
        md.update(data, "utf8");
        const signature = forge.util.encode64(privateKey.sign(md));
        await this.verifySignature(data, signature, publicKeyPem, flutter);
        return signature;
      } catch (error) {
        console.error("errorverifysignature", JSON.stringify(error));
        return null;
      }
    },
    async verifySignature(data, signatureBase64, publicKeyPem, flutter) {
      if (!publicKeyPem) {
        try {
          publicKeyPem = await flutter.callHandler("readsecure", "publicKey");
        } catch (error) {
          publicKeyPem = await flutter.callHandler("getdata", "publicKey");
        }
      }
      try {
        const publicKey = forge.pki.publicKeyFromPem(publicKeyPem);
        const md = forge.md.sha512.create();
        md.update(data, "utf8");
        const signature = forge.util.decode64(signatureBase64);
        return publicKey.verify(md.digest().bytes(), signature);
      } catch (error) {
        console.error("errorverify", JSON.stringify(error));
        return false;
      }
    },
    generateRandom(characters, length) {
      let result = "";
      const charactersLength = characters.length;
      for (let i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength),
        );
      }
      return result;
    },
    randomCharacter(length) {
      return this.generateRandom(
        `ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789`,
        length,
      );
    },
    randomNumber(length) {
      return this.generateRandom(`0123456789`, length);
    },
    getflutter() {
      let wait = 0;
      while (!window["flutter_inappwebview"]) {
        setTimeout(() => {}, 100);
        if (wait++ >= 100) {
          break;
        }
      }
      return window["flutter_inappwebview"];
    },
    waitForFlutter() {
      if (window.flutter_inappwebview) {
        return Promise.resolve(window.flutter_inappwebview);
      }
      return new Promise((resolve) => {
        let count = 0;
        const interval = setInterval(() => {
          count++;
          if (window.flutter_inappwebview) {
            clearInterval(interval);
            resolve(window.flutter_inappwebview);
          } else if (count >= 50) {
            clearInterval(interval);
            resolve(null);
          }
        }, 100);
      });
    },
    getmachinekey(device) {
      let savedKey = localStorage.getItem("app_machine_key");
      if (savedKey) {
        if (window["flutter_inappwebview"]) {
          window["flutter_inappwebview"].callHandler(
            "setdata",
            "machinekey",
            savedKey,
          );
        }
        return savedKey;
      }

      if (!device) return "";
      let output = "";
      if (device["devicetype"]) {
        output += device["devicetype"];
      }
      if (device["devicename"]) {
        output += device["devicename"];
      }
      if (device["deviceversion"]) {
        output += device["deviceversion"];
      }
      if (device["deviceidentifier"]) {
        if (
          !device["deviceidentifier"] ||
          device["deviceidentifier"] === "" ||
          device["deviceidentifier"] === "unknown" ||
          device["deviceidentifier"] === "UNKNOWN"
        ) {
          device["deviceidentifier"] =
            device["firebasetokenid"] ??
            device["huaweitoken"] ??
            this.randomCharacter(10);
        }
        output += device["deviceidentifier"];
      }
      if (device["all"]) {
        try {
          const all = JSON.parse(device["all"]);
          if (all["androidId"]) {
            if (all["androidId"] === "unknown") {
              all["androidId"] =
                device["firebasetokenid"] ?? this.randomCharacter(10);
            }
            output += all["androidId"];
          }
        } catch (error) {
          console.error("errorfirebasetokenid", error);
        }
      }
      if (output) {
        localStorage.setItem("app_machine_key", output);
      }
      if (window["flutter_inappwebview"]) {
        window["flutter_inappwebview"].callHandler(
          "setdata",
          "machinekey",
          output,
        );
      }
      return output;
    },
    /**
     * Returns the device fields the API expects (including firebaseTokenId).
     * iOS only receives the FCM token after APNS registration, so re-read the
     * device from the native bridge when the cached payload has no token yet.
     */
    async getDeviceFields({ retries = 0, delay = 1000 } = {}) {
      let device = this.device || this.$store.get("device") || null;
      if (!device || !device["firebasetokenid"]) {
        const flutter = this.flutter || this.getflutter();
        if (flutter) {
          for (let attempt = 0; attempt <= retries; attempt++) {
            try {
              const fresh = await flutter.callHandler("getdevice");
              if (fresh) {
                device = fresh;
                this.device = fresh;
                this.$store.set("device", fresh);
              }
            } catch (error) {
              console.error("errorgetdevicefields", JSON.stringify(error));
              break;
            }
            if (device && device["firebasetokenid"]) break;
            if (attempt < retries) {
              await new Promise((resolve) => setTimeout(resolve, delay));
            }
          }
        }
      }
      if (!device) return {};
      this.device = device;
      const fields = {};
      if (device["firebasetokenid"]) {
        fields["firebaseTokenId"] = device["firebasetokenid"];
      }
      if (device["huaweitoken"]) {
        fields["huawei_token"] = device["huaweitoken"];
      }
      if (device["devicename"]) {
        fields["deviceName"] = device["devicename"];
      }
      if (device["devicetype"]) {
        fields["devicePlatform"] = device["devicetype"];
      }
      const machineKey = this.getmachinekey(device);
      if (machineKey) {
        fields["machineKey"] = machineKey;
      }
      return fields;
    },
    /**
     * Resolves the FCM token on its own, without touching the device payload or
     * machineKey used by existing API parameters.
     */
    async getFirebaseTokenId({ retries = 0, delay = 1000 } = {}) {
      let device = this.device || this.$store.get("device") || null;
      if (device && device["firebasetokenid"]) {
        return device["firebasetokenid"];
      }
      const flutter = this.flutter || this.getflutter();
      if (flutter) {
        for (let attempt = 0; attempt <= retries; attempt++) {
          try {
            const fresh = await flutter.callHandler("getdevice");
            if (fresh) {
              device = fresh;
              this.$store.set("device", fresh);
            }
          } catch (error) {
            console.error("errorgetfirebasetokenid", JSON.stringify(error));
            break;
          }
          if (device && device["firebasetokenid"]) break;
          if (attempt < retries) {
            await new Promise((resolve) => setTimeout(resolve, delay));
          }
        }
      }
      return device ? device["firebasetokenid"] : undefined;
    },
    isnumber(str) {
      return /^\d+$/.test(str);
    },
    isValidStoredProfile(item) {
      if (!item || typeof item !== "object") return false;
      const hasId =
        item.userId || item.userid || item.id || item.username || item.userName;
      const hasToken = item.access_token || item.accessToken || item.token;
      return !!(hasId && hasToken);
    },
    parseStoredProfiles(data) {
      if (!data || data === "null" || data === "undefined" || data === "") {
        return [];
      }
      let parsed = null;
      try {
        parsed = typeof data === "string" ? JSON.parse(data) : data;
      } catch (e) {
        console.error("errorparseStoredProfiles", JSON.stringify(e));
        return [];
      }
      if (Array.isArray(parsed)) {
        return parsed.filter((item) => this.isValidStoredProfile(item));
      }
      if (parsed && typeof parsed === "object") {
        return this.isValidStoredProfile(parsed) ? [parsed] : [];
      }
      return [];
    },
    async getStoredProfiles(key) {
      const fl = this.flutter || this.getflutter();
      if (!fl) return [];
      try {
        const data = await fl.callHandler("readsecure", key);
        return this.parseStoredProfiles(data);
      } catch (e) {
        console.error(`errorgetStoredProfiles ${key}`, JSON.stringify(e));
        return [];
      }
    },
    async saveProfileToStorage(key, userObj) {
      const fl = this.flutter || this.getflutter();
      if (!fl || !userObj) return [];
      try {
        const normalized = {
          ...userObj,
          userCategoryId:
            userObj.userCategoryId != null
              ? Number(userObj.userCategoryId)
              : userObj.usercategoryid != null
              ? Number(userObj.usercategoryid)
              : null,
          usercategoryid:
            userObj.userCategoryId != null
              ? Number(userObj.userCategoryId)
              : userObj.usercategoryid != null
              ? Number(userObj.usercategoryid)
              : null,
          userId:
            userObj.userId != null
              ? Number(userObj.userId)
              : userObj.userid != null
              ? Number(userObj.userid)
              : null,
          userid:
            userObj.userId != null
              ? Number(userObj.userId)
              : userObj.userid != null
              ? Number(userObj.userid)
              : null,
          username: userObj.username || userObj.userName,
          userName: userObj.username || userObj.userName,
          access_token: userObj.access_token || userObj.accessToken,
          accessToken: userObj.access_token || userObj.accessToken,
          refresh_token: userObj.refresh_token || userObj.refreshToken,
          refreshToken: userObj.refresh_token || userObj.refreshToken,
        };

        const targetKey =
          key ||
          (normalized.userCategoryId == 2
            ? "branchProfile"
            : "customerProfile");

        // Only keep 1 profile per key — always overwrite with the latest
        const newList = [normalized];

        await fl.callHandler("writesecure", targetKey, JSON.stringify(newList));
        return newList;
      } catch (e) {
        console.error(`errorsaveProfileToStorage ${key}`, JSON.stringify(e));
        return [];
      }
    },
    async removeProfileFromStorage(key, profileObj) {
      const fl = this.flutter || this.getflutter();
      if (!fl || !profileObj) return [];
      try {
        const userKey =
          profileObj.userId ||
          profileObj.userid ||
          profileObj.id ||
          profileObj.username;
        const objIsBranch =
          profileObj.userCategoryId == 2 || profileObj.usercategoryid == 2;

        const filterOut = (list, isTargetKey) => {
          return (list || []).filter((p) => {
            if (!p) return false;
            const pIsBranch = p.userCategoryId == 2 || p.usercategoryid == 2;
            if (!isTargetKey) {
              if (pIsBranch === objIsBranch) {
                const pKey = p.userId || p.userid || p.id || p.username;
                if (userKey && pKey && String(userKey) === String(pKey))
                  return false;
                if (
                  profileObj.username &&
                  p.username &&
                  String(profileObj.username) === String(p.username)
                )
                  return false;
              }
              if (
                profileObj.access_token &&
                p.access_token &&
                profileObj.access_token === p.access_token
              ) {
                return false;
              }
              return true;
            }

            const pKey = p.userId || p.userid || p.id || p.username;
            if (userKey && pKey && String(userKey) === String(pKey))
              return false;
            if (
              profileObj.username &&
              p.username &&
              String(profileObj.username) === String(p.username)
            )
              return false;
            if (
              profileObj.phonenumber &&
              p.phonenumber &&
              String(profileObj.phonenumber) === String(p.phonenumber)
            )
              return false;
            if (
              profileObj.access_token &&
              p.access_token &&
              profileObj.access_token === p.access_token
            )
              return false;
            return true;
          });
        };

        const targetKey =
          key || (objIsBranch ? "branchProfile" : "customerProfile");
        const keysToClean = ["branchProfile", "customerProfile"];
        let targetUpdated = [];
        for (const k of keysToClean) {
          const list = await this.getStoredProfiles(k);
          const updated = filterOut(list, k === targetKey);
          await fl.callHandler("writesecure", k, JSON.stringify(updated));
          if (k === targetKey) {
            targetUpdated = updated;
          }
        }
        return targetUpdated;
      } catch (e) {
        console.error(
          `errorremoveProfileFromStorage ${key}`,
          JSON.stringify(e),
        );
        return [];
      }
    },
    async applyUserProfile(targetUser) {
      if (!targetUser) return;
      const normalizedUser = {
        ...targetUser,
        userCategoryId:
          targetUser.userCategoryId != null
            ? Number(targetUser.userCategoryId)
            : targetUser.usercategoryid != null
            ? Number(targetUser.usercategoryid)
            : null,
        usercategoryid:
          targetUser.userCategoryId != null
            ? Number(targetUser.userCategoryId)
            : targetUser.usercategoryid != null
            ? Number(targetUser.usercategoryid)
            : null,
        userId:
          targetUser.userId != null
            ? Number(targetUser.userId)
            : targetUser.userid != null
            ? Number(targetUser.userid)
            : null,
        userid:
          targetUser.userId != null
            ? Number(targetUser.userId)
            : targetUser.userid != null
            ? Number(targetUser.userid)
            : null,
        username: targetUser.username || targetUser.userName,
        userName: targetUser.username || targetUser.userName,
        access_token: targetUser.access_token || targetUser.accessToken,
        accessToken: targetUser.access_token || targetUser.accessToken,
        refresh_token: targetUser.refresh_token || targetUser.refreshToken,
        refreshToken: targetUser.refresh_token || targetUser.refreshToken,
      };

      this.$store.set("user", normalizedUser);
      if (normalizedUser.salehistory_url) {
        this.$store.set("salehistory_url", normalizedUser.salehistory_url);
      }
      const fl = this.flutter || this.getflutter();
      if (fl) {
        await fl.callHandler("setdata", "loginResponse", normalizedUser);
        if (normalizedUser.username) {
          await fl.callHandler(
            "setdata",
            "username",
            `${normalizedUser.username}`,
          );
        }
      }
      this.$forceUpdate();
      try {
        if (fl) {
          await fl.callHandler("reload");
        } else {
          window.location.reload();
        }
      } catch (e) {
        window.location.reload();
      }
    },
    async refreshToken(token = null) {
      return refreshToken(token);
    },
    scheduleTokenRefresh(user = null) {
      return scheduleTokenRefresh(user);
    },
    async clearUserSession(redirectTo = null) {
      return clearUserSession(redirectTo);
    },

    expandRange(from, to) {
      const a = parseInt(from, 10);
      const b = parseInt(to, 10);
      const out = [];
      for (let n = a; n <= b; n++) {
        out.push(String(n).padStart(6, "0"));
      }
      return out;
    },

    /** Simple seeded PRNG (mulberry32) */
    mulberry32(seed) {
      let t = seed >>> 0;
      return function () {
        t += 0x6d2b79f5;
        let r = Math.imul(t ^ (t >>> 15), 1 | t);
        r ^= r + Math.imul(r ^ (r >>> 7), 61 | r);
        return ((r ^ (r >>> 14)) >>> 0) / 4294967296;
      };
    },

    shuffleInPlace(arr, rand) {
      for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(rand() * (i + 1));
        [arr[i], arr[j]] = [arr[j], arr[i]];
      }
      return arr;
    },

    /**
     * @param {object} model - response.model from getCandidateBuckets
     * @param {number} count - how many digits user wants (1..1000)
     */
    pickSixDigitsFromBuckets(model, count) {
      if (!model?.ranges?.length) throw new Error("No ranges");
      if (Date.now() > new Date(model.expiresDateTime).getTime()) {
        throw new Error("Bucket expired — call getCandidateBuckets again");
      }

      const excluded = new Set(model.excludedDigits || []);
      const pool = [];

      for (const r of model.ranges) {
        for (const d of this.expandRange(r.from, r.to)) {
          if (!excluded.has(d)) pool.push(d);
        }
      }

      // Example: first range 030400–030499 → 100 digits, minus any excluded in that band
      // Your sample excluded "036833" inside second range, etc.

      if (pool.length < count) {
        throw new Error(
          `Only ${pool.length} candidates left; request more buckets or lower count`,
        );
      }

      // Mix server seed with a bit of client entropy (optional but recommended)
      const seed =
        (model.randomSeed >>> 0) ^
        (Date.now() & 0xffff) ^
        ((Math.random() * 0xffffffff) >>> 0);

      this.shuffleInPlace(pool, this.mulberry32(seed));

      const used = new Set();
      const picked = [];
      for (const d of pool) {
        if (used.has(d)) continue;
        used.add(d);
        picked.push(d);
        if (picked.length === count) break;
      }
      return picked;
    },
  },
};
